import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "../../formSection/formSection";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { imageUploadUrlPublic } from "services/redux/fileUpload/action";
import * as moment from "moment";
import ModalPop from "../../modal/modal";
import s from "./addPayment.module.css";
import { showToast } from "services/utils/networks/network";
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import AppNotifications from "components/sales/appNotifications/appNotifications";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DocumentView from "components/sales/downloadDocView/documentView";

const AddPaymentPopup = ({
  showPaymentPopup,
  onClosePopup = () => {},
  imageUploadUrlPublic,
  businessId,
  invoiceId,
  contractId,
  siteNumber,
  businessName,
  isEdit = false,
  rowData = {},
  isView = false,
  lateFee = 0,
  lateFeeApplicable = false,
  dueDate = "",
  documentUploadUrlPublic,
  documentUrlDataPublic,
  verifyInvoicesNumbers,
  verifyInvoiceNumbersWithRecon,
  editClientDetails,
  editClientDetailsForTan,
  invoiceNumber,
  documentType
}) => {
  const [inputList, setInputList] = useState([
    {
      received_amt: isEdit ? rowData?.amount : "",
      retention_charge: isEdit ? rowData?.retention_amount : "",
      tag_charge: isEdit ? rowData?.tag_amount : "",
      payment_mode: isEdit ? rowData?.payment_mode : "",
      reference_number: isEdit ? rowData?.payment_reference : "",
      tds_amt: isEdit ? rowData?.tds : "",
      remark: isEdit
        ? rowData?.remarks
        : isView
        ? rowData?.finance_remarks
        : "",
      payment_photo: "",
      adv_payment_date: isEdit ? rowData?.transaction_date : "",
      status: isEdit ? rowData?.status : "",
      bank: isEdit ? rowData?.bank : "",
      late_fee: "",
      is_forcefully_settled: "No",
      tan_number: "",
      confirm_tan_number: "",
      tan_attachment: "",
      client_id: "",
    },
  ]);
  const [payData, setPayData] = useState();
  const [isTarget, setIsTarget] = useState("");
  const [isFocus1, setIsFous1] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showApiSuccess, setShowApiSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lateFeeDateCheck, setLateFeeDateCheck] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [apiResponse, setApiResponse] = useState(false);
  const [tanNumber, setTanNumber] = useState("");
  const [tanDocument, setTanDocument] = useState("");
  const [tanDetails, setTanDetails] = useState(false);
  const [clientId, setClientId] = useState("");

  const handleDateChange = (e, index, name) => {
    const current_datetime = moment(e).format("YYYY-MM-DD");
    if (current_datetime >= dueDate) {
      setLateFeeDateCheck(true);
      const list = [...inputList];
      list[index]["late_fee"] = lateFee;
      setInputList(list);
    } else {
      setLateFeeDateCheck(false);
      const list = [...inputList];
      list[index]["late_fee"] = 0;
      setInputList(list);
    }
    const list = [...inputList];
    list[index][name] = current_datetime;
    setInputList(list);
  };
  const handledropDownChange = (e, index, name) => {
    // console.log(e);
    const { value, id } = e;
    const list = [...inputList];
    list[index][name] = id;
    setInputList(list);
  };

  const handleConstInput = (e, index, name) => {
    // console.log(e);
    const list = [...inputList];
    list[index][name] = e;
    setInputList(list);
  };

  function handleRemoveAll() {
    setInputList([
      {
        received_amt: "",
        retention_charge: "",
        tag_charge: "",
        adv_amount: "",
        payment_mode: "",
        other_amount: "",
        reference_number: "",
        tds_check: "",
        tds_amt: "",
        remark: "",
        gst_amt: "",
        payment_photo: "",
        adv_payment_date: "",
        status: "",
        bank: "",
        late_fee: "",
        is_forcefully_settled: "",
        tan_number: "",
        confirm_tan_number: "",
        tan_attachment: "",
        client_id: "",
      },
    ]);
  }

  async function submit() {
    try {
      setIsLoading(true);
      let url;
      if (isEdit) {
        url = Config.preSalesList.updatePaymentRequest;
      } else {
        url = Config.preSalesList.addPayment;
      }
      const payload = {
        request_id: isEdit ? rowData?.request_id : undefined,
        business_id: businessId,
        invoice_id: invoiceId,
        contract_id: contractId,
        site_number: siteNumber,
        payment_mode: inputList[0].payment_mode,
        amount: inputList[0].received_amt,
        retention_amount: inputList[0].retention_charge,
        transaction_date: inputList[0].adv_payment_date,
        bank_name: inputList[0].bank,
        tds_check: inputList[0].tds_check,
        tds_amt: inputList[0].tds_amt,
        payment_photo: inputList[0].payment_photo,
        reference_number: inputList[0].reference_number,
        status: inputList[0].status,
        remark: inputList[0].remark,
        late_fee: inputList[0].late_fee,
        is_forcefully_settled: inputList[0].is_forcefully_settled,
        tan_number: payData?.tan_number ?? tanNumber,
        confirm_tan_number: inputList[0].confirm_tan_number,
        tan_attachment: payData?.tan_attachment ?? tanDocument,
        client_id: clientId,
        document_type: documentType
      };

      // console.log("FINAL payload", payload);

      const { data } = await axios.post(url, payload);
      console.log(data);
      onClosePopup();
      setConfirmationModal(false);
      setApiResponse(false);
      setTanNumber("");
      setTanDocument("");
      setTanDetails(false);
      setClientId("");

      if (data.response.message) {
        if (data.response.status === false) {
          toast.error(data.response.message);
        } else {
          toast.success(data.response.message);
        }
      } else {
        toast.error("Something went wrong, Please try again");
      }
      // onClosePopup();
      // toast.success('Add payment request submitted successfully')
      handleRemoveAll();
      setIsLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong, Please try again"
      );
      setIsLoading(false);
    }
  }

  const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;
  const isTdsPresent = inputList[0].tds_amt > 0;

  console.log("invoiceNumber: ", invoiceNumber)

  useEffect(() => {
    if (invoiceNumber !== undefined && invoiceNumber !== "") {
      const payload = {
        document_numbers: [
          {
            document_number: invoiceNumber,
            document_type: documentType
          }
        ]
      };
      const fetchData = async () => {
        setIsLoading(true);
        const res = await verifyInvoicesNumbers(payload);
        if (res?.status === true) {
          setApiResponse(true);
          setClientId(res?.data?.client_id);
          if (res?.data?.tan_number) {
            setTanDocument(res?.data?.tan_number_document);
            setTanNumber(res?.data?.tan_number);
            setPayData((prev) => ({
              ...prev,
              tan_number: res?.data?.tan_number,
              tan_attachment: res?.data?.tan_number_document,
            }));
            setTanDetails(true);
          }
        }
        setIsLoading(false);
      };
      fetchData();
    }
  }, [invoiceNumber]);

  const handleSubmitEditClientDetails = async () => {
    if(isTdsPresent){
      if((payData?.tan_number == "" && tanNumber == "") || payData?.confirm_tan_number == "" || (payData?.tan_attachment == "" && tanDocument == "")){
        toast.error("TAN details missing, please fill all TAN details")
        return false;
      }
    }
    if (apiResponse) {
      if (!tanDetails) {
        if (isTdsPresent) {
          const payload = {
            client_id: clientId,
            tan_number: payData?.tan_number,
            tan_number_document: payData?.tan_attachment,
          };
          setIsLoading(false);
          const res = await editClientDetails(payload);
          if (res?.status === true) {
            setConfirmationModal(true);
          } else {
            toast.error("Something went wrong");
          }
          setIsLoading(false);
        } else {
          if (payData.tan_number != "" || payData.tan_attachment != "") {
            const payload = {
              client_id: clientId,
              tan_number: payData?.tan_number,
              tan_number_document: payData?.tan_attachment,
            };
            setIsLoading(false);
            const res = await editClientDetails(payload);
            if (res?.status === true) {
              setConfirmationModal(true);
            } else {
              toast.error("Something went wrong");
            }
            setIsLoading(false);
          } else {
            setConfirmationModal(true);
          }
        }
      } else {
        setConfirmationModal(true);
      }
    }
  };

  const advancePayment = () => {
    return (
      <div className={s.root}>
        {inputList.map((x, i) => {
          return (
            <div>
              <div>
                <h4>
                  Business Name: {businessName} {lateFee}
                </h4>
                <h4>Site Number: {siteNumber}</h4>
              </div>
              <div className={s.parallel_fields}>
                <ConstantInput
                  label={'Document Number'}
                  disabled={true}
                  value={invoiceNumber}
                  required
                  isStarRequired
                />
                <ConstantInput
                  label={'Document Type'}
                  disabled={true}
                  value={documentType}
                  required
                  isStarRequired
                />
                <DropDownInput
                  label={localization.paymentMode}
                  disabled={isView}
                  data={[
                    { id: "Cash", name: "Cash" },
                    { id: "Cheque", name: "Cheque" },
                    { id: "NEFT", name: "NEFT" },
                    { id: "IMPS", name: "IMPS" },
                    { id: "RTGS", name: "RTGS" },
                    { id: "UPI", name: "UPI" },
                    { id: "NACH", name: "NACH" },
                    { id: "PDC_CHEQUE", name: "PDC_CHEQUE" },
                    { id: "TDS_SETTLEMENT", name: "TDS_SETTLEMENT" },
                  ]}
                  required
                  value={isEdit || isView ? rowData?.payment_mode : ""}
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      payment_mode: val.id,
                    });
                    handledropDownChange(val, i, "payment_mode");
                    handledropDownChange({ id: null, value: "" }, i, "status");
                  }}
                  // onChange={e => handleInputChange(e, i)}

                  isStarRequired={true}
                />

                <ConstantInput
                  label={localization.referenceNumber}
                  disabled={isView}
                  // value={locationData.billGeoState}
                  value={isEdit || isView ? rowData?.payment_reference : ""}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      reference_number: val,
                    });
                    handleConstInput(val, i, "reference_number");
                  }}
                  required
                  isStarRequired
                />
              </div>
              <div className={s.parallel_fields}>
                <FormGroup
                  className={`date custom_date_picker ${
                    isFocus1 ? "active-date" : ""
                  }`}
                >
                  <label>
                    {localization.transactionDate}
                    <span className="label-star" style={{ color: "red" }}>
                      {" "}
                      *{" "}
                    </span>
                  </label>
                  <DatePickerInput
                    // onChange={handleDateChange1}
                    onChange={(e) => handleDateChange(e, i, "adv_payment_date")}
                    // onShow={() => setIsFous1(true)}
                    value={isEdit || isView ? rowData?.transaction_date : ""}
                    autoClose
                    disabled={isView}
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.transactionDate}
                    </label>
                  )}
                </FormGroup>
                <DropDownInput
                  label={localization.status}
                  value={isEdit || isView ? rowData?.status : ""}
                  data={
                    x.payment_mode == "Cash"
                      ? [
                          {
                            id: "DEPOSITED IN BANK",
                            name: "Deposited in Bank",
                          },
                          {
                            id: "COLLECTED FROM CLIENT",
                            name: "Collected from Client",
                          },
                          {
                            id: "DEPOSITED TO FINANCE",
                            name: "Deposited to Finance",
                          },
                        ]
                      : x.payment_mode === "Cheque"
                      ? [
                          {
                            id: "DEPOSITED IN BANK",
                            name: "Deposited in Bank",
                          },
                          {
                            id: "DEPOSITED TO FINANCE",
                            name: "Deposited to Finance",
                          },
                        ]
                      : [
                          {
                            id: "ONLINE TRANSACTION BY CLIENT",
                            name: "Online Transaction by Client",
                          },
                        ]
                  }
                  required
                  errorMsg={localization.paymentMode}
                  controlledValue={inputList[0].status}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      status: val.id,
                    });
                    handledropDownChange(val, i, "status");
                  }}
                  // onChange={e => handleInputChange(e, i)}
                  disabled={x.payment_mode === "" || isView}
                  isStarRequired={true}
                />
              </div>
              <div className={s.parallel_fields}>
                <DropDownInput
                  value={isEdit || isView ? rowData?.bank : ""}
                  label="Select Bank"
                  disabled={isView}
                  data={[
                    {
                      id: "HDFC",
                      name: "HDFC",
                    },
                    {
                      id: "IDFC",
                      name: "IDFC",
                    },
                    {
                      id: "ICICI",
                      name: "ICICI",
                    },
                    {
                      id: "IDBI",
                      name: "IDBI",
                    },
                    {
                      id: "STANDARD_CHARTERED",
                      name: "STANDARD_CHARTERED",
                    },
                    {
                      id: "YES_BANK",
                      name: "YES_BANK",
                    },
                  ]}
                  required
                  errorMsg={localization.paymentMode}
                  getIdValue={(val) => {
                    setPayData({
                      ...payData,
                      bank: val.id,
                    });
                    handledropDownChange(val, i, "bank");
                  }}
                  // onChange={e => handleInputChange(e, i)}
                  isStarRequired={true}
                />
              </div>
              {inputList[0].payment_mode == "TDS_SETTLEMENT" && (
                <div className="col-md-12">
                  <h5 style={{color: "#ff8000"}}>*Only TDS amount is allowed in TDS Settlement payment mode.</h5>
                </div>
              )}
              <div className={s.field_combo}>

              {inputList[0].payment_mode !== "TDS_SETTLEMENT" ? (
              <>
                <ConstantInput
                  value={isEdit || isView ? rowData?.amount : ""}
                  label="Received Amount"
                  type="number"
                  disabled={isView}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      received_amt: val,
                    });
                    handleConstInput(val, i, "received_amt");
                  }}
                  required={true}
                  isStarRequired
                />
                <ConstantInput
                  label="Retention Amount"
                  value={isEdit || isView ? rowData?.retention_amount : ""}
                  type="number"
                  disabled={isView}
                  handleChange={(val) => {
                    setPayData({
                      ...inputList,
                      retention_charge: val,
                    });
                    handleConstInput(val, i, "retention_charge");
                  }}
                  required={true}
                  isStarRequired
                />
              </>
            ) : (
              <>
                <ConstantInput
                  value={'0'}
                  label="Received Amount"
                  type="number"
                  disabled={true}
                  required={true}
                  isStarRequired
                />
                <ConstantInput
                  value={'0'}
                  label="Retention Amount"
                  type="number"
                  disabled={true}
                  required={true}
                  isStarRequired
                />
              </>
            )}

                <ConstantInput
                  label={localization.tdsAmount}
                  value={isEdit || isView ? rowData?.tds : ""}
                  type="number"
                  disabled={isView}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      tds_amt: val,
                    });
                    handleConstInput(val, i, "tds_amt");
                  }}
                  required
                  isStarRequired
                />
              </div>
              <br />
              {/* TAN addition sta
              \rts */}
              {(isTdsPresent && tanNumber == "" && tanDocument == "") && (
                <>
                  <div className="row">
                    <div className="col-md-4">
                      <ConstantInput
                        label={localization.tanNumber}
                        type="password"
                        handleChange={(val) => {
                          setPayData({
                            ...payData,
                            tan_number: val,
                          });
                        }}
                        onPaste={(e) => e.preventDefault()}
                        isStarRequired={true}
                      />
                      {payData?.tan_number &&
                        !tanRegex.test(payData?.tan_number) && (
                          <div style={{ color: "red" }}>
                            Invalid TAN number format
                          </div>
                        )}
                    </div>
                    <div className="col-md-4">
                      <ConstantInput
                        label={localization.confirmTanNumber}
                        maxLength={10}
                        handleChange={(val) => {
                          setPayData({
                            ...payData,
                            confirm_tan_number: val,
                          });
                        }}
                        onPaste={(e) => e.preventDefault()}
                        isStarRequired={true}
                      />
                      {payData?.confirm_tan_number &&
                        payData?.tan_number !==
                          payData?.confirm_tan_number && (
                          <div style={{ color: "red" }}>
                            TAN numbers do not match
                          </div>
                        )}
                    </div>
                    <div className="col-md-4">
                      <FileUpload
                        id="docs"
                        accept=".pdf,.png,.jpg"
                        documentUploadUrl={documentUploadUrlPublic}
                        documentUrlData={documentUrlDataPublic}
                        onChange={(val) => {
                          setPayData({ ...payData, tan_attachment: val });
                        }}
                        required
                      >
                        <span className="btn btn-transparent">
                          {localization.tanAttachment}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      </FileUpload>
                    </div>
                  </div>
                </>
              )}
              {tanDetails && (
                <>
                  <div className="row">
                    <div className="col-md-8">
                      <ConstantInput
                        label={localization.tanNumber}
                        type="text"
                        handleChange={(val) => {
                          setPayData({
                            ...payData,
                            tan_number: val,
                          });
                        }}
                        value={tanNumber}
                        disabled={true}
                        isStarRequired={true}
                      />
                    </div>
                    <div className="col-md-4">
                      <a
                        href={tanDocument}
                        className="btn btn-primary btn-sm"
                        download
                        target="_blank"
                      >
                        <span>
                          Tan Proof<span style={{ color: "red" }}>*</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </>
              )}
              {/* TAN addition ends */}

              <div className={"details-list"}>
                <DocumentView
                  title={`Payment Proof`}
                  attachment={rowData?.proof_image?.[0]}
                />
              </div>
              {rowData?.proof_image?.[1] && (
                <div className={"details-list"}>
                  <DocumentView
                    title={`Payment Proof`}
                    attachment={rowData?.proof_image?.[1]}
                  />
                </div>
              )}

              <br />
              <div className={s.field_combo}>
                <ConstantInput
                  value={dueDate}
                  label="Late Fee Due Date"
                  //  type="number"
                  disabled={true}

                  //  required={true}
                  //  isStarRequired
                />
                {lateFeeApplicable && lateFeeDateCheck ? (
                  <>
                    <ConstantInput
                      value={isEdit || isView ? rowData?.amount : lateFee}
                      label="Late Fee Amount"
                      type="number"
                      disabled={isView}
                      handleChange={(val) => {
                        setPayData({
                          ...inputList,
                          late_fee: val,
                        });
                        handleConstInput(val, i, "late_fee");
                      }}
                      required={true}
                      isStarRequired
                    />
                    <DropDownInput
                      value={
                        isEdit || isView ? rowData?.is_forcefully_settled : "No"
                      }
                      label="Forcefully Settled"
                      disabled={isView}
                      data={[
                        {
                          id: "Yes",
                          name: "Yes",
                        },
                        {
                          id: "No",
                          name: "No",
                        },
                      ]}
                      required
                      errorMsg={"Forcefully Settled"}
                      getIdValue={(val) => {
                        setPayData({
                          ...payData,
                          is_forcefully_settled: val.id,
                        });
                        handledropDownChange(val, i, "is_forcefully_settled");
                      }}
                      // onChange={e => handleInputChange(e, i)}
                      isStarRequired={true}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
              <br />
              <div className={s.parallel_fields}>
                <div>
                  <ConstantInput
                    label="User Remark"
                    value={rowData?.remarks || ""}
                    disabled={isView}
                    // value={locationData.billGeoState}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />
                  {isView && (
                    <ConstantInput
                      label="Finance Remark"
                      value={rowData?.finance_remark || ""}
                      disabled={isView}
                      handleChange={(val) => {
                        setPayData({
                          ...payData,
                          remark: val,
                        });
                        handleConstInput(val, i, "remark");
                      }}
                    />
                  )}
                </div>
                <div>
                  {!isView && (
                    <FileUpload
                      id={"uploadAdvPay" + i}
                      multiple
                      disabled={isView}
                      accept="image/*"
                      required
                      isStarRequired
                      documentUploadUrl={imageUploadUrlPublic}
                      onChange={(val) => {
                        // setPayData({ ...payData, payment_photo: val.toString() })
                        handleConstInput(val.toString(), i, "payment_photo");
                      }}
                    >
                      <span className="btn btn-transparent">
                        {localization.uploadPaymentPhotos}
                      </span>
                    </FileUpload>
                  )}
                </div>
              </div>
              <div className={s.parallel_fields}>
                {isView && (
                  <ConstantInput
                    label="Transaction Id"
                    value={rowData?.bank_transaction_id || ""}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />
                )}
                {isView && (
                  <ConstantInput
                    label="ERP Voucher Number"
                    value={rowData?.erp_voucher_number || ""}
                    disabled={isView}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val, i, "remark");
                    }}
                  />
                )}
              </div>
              {!isView && (
                <>
                  <hr style={{ marginTop: "24px" }} />
                  <div className={s.button_box}>
                    <div className={s.button}>
                      <Button
                        onClick={() => {
                          if (isTdsPresent && tanNumber == "" && tanDocument == "") {
                            handleSubmitEditClientDetails();
                          } else if (isTdsPresent && tanNumber !== "" && tanDocument !== "") {
                            setConfirmationModal(true);
                          } else if(!isTdsPresent) {
                            setConfirmationModal(true);
                          }
                        }}                      
                        disabled={
                          x.payment_mode === "" ||
                          x.reference_number === "" ||
                          x.transaction_date === "" ||
                          x.status === "" ||
                          x.bank === "" ||
                          x.tds_amt === "" ||
                          // x.received_amt === "" ||
                          // x.retention_charge === "" ||
                          x.payment_photo === "" ||
                          isView ||
                          isLoading
                        }
                      >
                        {isEdit ? "Update" : "Submit"}
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <ModalPop
        title={
          isEdit
            ? "Edit Payment Request"
            : isView
            ? "View Payment Request"
            : "Add Payment"
        }
        show={showPaymentPopup}
        handleModalHide={() => {
          onClosePopup();
          handleRemoveAll();
          setApiResponse(false);
          setTanNumber("");
          setTanDocument("");
          setTanDetails(false);
          setClientId("");
        }}
      >
        <Fragment>
          <FormSection>{advancePayment()}</FormSection>
        </Fragment>
      </ModalPop>
      <ModalPop
        title={"Please Confirm Your Add Payment Details"}
        show={confirmationModal}
        handleModalHide={() => {
          setConfirmationModal(false);
          setApiResponse(false);
          setTanNumber("");
          setTanDocument("");
          setTanDetails(false);
          setClientId("");
        }}
      >
        <Fragment>
          <FormSection>
            <div className={s.root}>
              <div className={s.root}>
                {inputList.map((x, i) => {
                  return (
                    <div>
                      <div>
                        <h4>
                          Business Name: {businessName} {lateFee}
                        </h4>
                        <h4>Site Number: {siteNumber}</h4>
                      </div>
                      <div className={s.parallel_fields}>
                        <ConstantInput
                          label={localization.paymentMode}
                          type="text"
                          disabled={true}
                          value={x?.payment_mode}
                        />
                        <ConstantInput
                          label={localization.referenceNumber}
                          type="text"
                          disabled={true}
                          value={x?.reference_number}
                        />
                      </div>
                      <div className={s.parallel_fields}>
                        <FormGroup
                          className={`date custom_date_picker ${
                            isFocus1 ? "active-date" : ""
                          }`}
                        >
                          <div className="col-sm-12 col-ms-12 ">
                            <ConstantInput
                              label={localization.transactionDate}
                              type="text"
                              disabled={true}
                              value={x?.adv_payment_date}
                              className="my-custom-datepicker-component "
                            />
                          </div>
                        </FormGroup>
                        <ConstantInput
                          label={localization.status}
                          type="text"
                          disabled={true}
                          value={x?.status}
                        />
                      </div>
                      <div className={s.parallel_fields}>
                        <ConstantInput
                          label={localization.bankName}
                          type="text"
                          disabled={true}
                          value={x?.bank}
                        />
                      </div>
                      <div className={s.field_combo}>
                        <ConstantInput
                          label={"Received Amount"}
                          type="text"
                          disabled={true}
                          value={x?.received_amt ?? '0'}
                        />
                        <ConstantInput
                          label={"Retention Amount"}
                          type="text"
                          disabled={true}
                          value={x?.retention_charge ?? '0'}
                        />
                        <ConstantInput
                          label={localization.tdsAmount}
                          type="text"
                          disabled={true}
                          value={x?.tds_amt}
                        />
                      </div>
                      <br />
                      <div className={s.field_combo}>
                        <ConstantInput
                          label="Late Fee Due Date"
                          type="text"
                          disabled={true}
                          value={dueDate}
                        />

                        {lateFeeApplicable && lateFeeDateCheck ? (
                          <>
                            <ConstantInput
                              label="Late Fee Amount"
                              type="text"
                              disabled={true}
                              value={x?.late_fee}
                            />
                            <ConstantInput
                              label="Forcefully Settled"
                              type="text"
                              disabled={true}
                              value={x?.is_forcefully_settled}
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      <br />
                      <div className={s.parallel_fields}>
                        <div>
                          <ConstantInput
                            label="User Remark"
                            type="text"
                            disabled={true}
                            value={x?.remark}
                          />
                          {isView && (
                            <ConstantInput
                              label="Finance Remark"
                              type="text"
                              disabled={true}
                              value={x?.remark}
                            />
                          )}
                        </div>
                      </div>
                      <div className={s.parallel_fields}>
                        {isView && (
                          <ConstantInput
                            label="Transaction Id"
                            type="text"
                            disabled={true}
                            value={x?.remark}
                          />
                        )}
                        {isView && (
                          <ConstantInput
                            label="ERP Voucher Number"
                            type="text"
                            disabled={true}
                            value={x?.remark}
                          />
                        )}
                      </div>
                      <div
                        className="confirm-button"
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="col-md-6 col-sm-6">
                          <div className={s.button} style={{ width: "36%" }}>
                            <Button onClick={() => submit()}>
                              {"Final Submit"}
                            </Button>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <div className={s.button}>
                            <Button onClick={() => {
                                setConfirmationModal(false);
                            }}>
                              {"Go Back"}
                            </Button>

                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </FormSection>
        </Fragment>
      </ModalPop>
    </>
  );
};
AddPaymentPopup.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AddPaymentPopup);
